export const DiscountsType = Object.freeze({
  ARDIDO: 'ARDIDO',
  AVARIADO: 'AVARIADO',
  IMPUREZA: 'IMPUREZA',
  QUEBRADO: 'QUEBRADO',
  UMIDADE: 'UMIDADE',
  VERDE: 'VERDE'
});